import { Controller } from '@hotwired/stimulus';
import axios from "axios";

export default class extends Controller {
    static targets = [ 'tryCode' ];

    connect() {
        this.formController = Stimulus.getControllerForElementAndIdentifier(this.element, 'axios-form');
        this.loading = false;
    }

    applyDiscount(e) {
        e.preventDefault();

        this.button = e.currentTarget;

        this.route = this.button.dataset.route;

        if (this.route) {
            this.validateDiscount();
        }
    }

    enableLoading() {
        this.loading = true;
        this.button.classList.add('loading');
    }

    disableLoading() {
        this.loading = false;
        this.button.classList.remove('loading');
    }

    validateDiscount() {
        if (this.loading) {
            return;
        }

        this.enableLoading();

        const formData = new FormData();

        formData.append('code', this.tryCodeTarget.value)

        this.removeErrors();

        axios.post(this.route, formData).then(response => {
            response = response.data.data;

            if (response && response.errors && Object.keys(response.errors).length) {
                this.formController.setupFormErrors(response.errors);
            } else if (response && response.general_error) {
                this.formController.setupFormGeneralError(response);
            } else if (response && response.general_success) {
                this.formController.setupFormGeneralSuccess(response);

                this.updatePrice(response);
            }

            this.disableLoading();
        }).catch(error => {
            console.log(error)
            error = error.response.data.data;

            if (error && error.errors && Object.keys(error.errors).length) {
                this.formController.setupFormErrors(error.errors);
            } else if (error && error.general_error) {
                this.formController.setupFormGeneralError(error);
            }

            this.disableLoading();
        })
    }

    updatePrice(response)
    {
        const totalPrice = this.element.querySelector('#total-price');
        const oldPrice = totalPrice.querySelector('.oldPrice').innerHTML;

        const percentage = document.createElement('span');
        const existingDiscount = this.element.querySelector('#total-price .text-secondary');

        percentage.classList.add('text-secondary');
        percentage.innerHTML = ` - ${response.off_total}`;

        totalPrice.innerHTML = `<span class="oldPrice">${oldPrice}</span>`;

        if (existingDiscount) {
            totalPrice.innerHTML += `<span class="text-secondary">${existingDiscount.innerHTML}</span>`;
            totalPrice.appendChild(percentage);
        } else {
            totalPrice.appendChild(percentage);
        }

        totalPrice.innerHTML += `<span class="total-sum"> = ${response.total}</span>`;
    }

    removeErrors() {
        const inputErrors = this.button.parentNode.parentNode.querySelectorAll('.input-error');
        const generalMessages = this.element.querySelectorAll('.general-success, .general-error');

        this.tryCodeTarget.classList.remove('invalid')

        generalMessages.forEach(msg => {
            msg.remove();
        })

        inputErrors.forEach(error => {
            error.remove();
        })
    }
}
